import { LoaderCircle } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

const SIZE = { sm: 'size-4', md: 'size-5', lg: 'size-8' };

/** The one loading spinner (DESIGN.md §11.1). Decorative: the surrounding label or `aria-busy` carries the state. */
export function Spinner({
  size = 'sm',
  className,
}: {
  size?: keyof typeof SIZE;
  className?: string;
}) {
  return (
    <LoaderCircle
      aria-hidden="true"
      className={twMerge('animate-spin motion-reduce:animate-none', SIZE[size], className)}
    />
  );
}
